import { ContentItem } from '@kentico/kontent-delivery';
import get from 'lodash/get';

import { Models } from './index';
import { ICaseStudyListItemProps } from '../components/case-study-list/case-study-list-item/case-study-article-list-item';
import { ICategoryModel } from './category-model';

export class CaseStudyListItemModel extends ContentItem {
  get id(): string {
    return get(this._config, 'system.id', '');
  }

  get language(): string {
    return get(this._config, 'system.language', '');
  }

  get slug(): string {
    return get(this._config, 'elements.basic_page_settings__url.value', '');
  }

  get title(): string {
    return get(this._config, 'elements.title_value.value', '');
  }

  get summary(): string {
    return get(this._config, 'elements.summary.value', '');
  }

  get image(): string {
    return get(this._config, 'elements.image.value[0]', '');
  }

  get categoryIndustry(): ICategoryModel[] {
    const industry = get(
      this._config,
      'elements.case_study_categories__industry.value',
      null
    );
    const modeledData = industry
      ? industry.map((categoryItem: ICategory) =>
          Models.CategoryModel.create(categoryItem)
        )
      : null;

    return modeledData;
  }

  get categoryTechnology(): ICategoryModel[] {
    const technology = get(
      this._config,
      'elements.case_study_categories__technology.value',
      null
    );
    const modeledData = technology
      ? technology.map((categoryItem: ICategory) =>
          Models.CategoryModel.create(categoryItem)
        )
      : null;

    return modeledData;
  }

  get categoryProject(): ICategoryModel[] {
    const project = get(
      this._config,
      'elements.case_study_categories__project.value',
      null
    );
    const modeledData = project
      ? project.map((categoryItem: ICategory) =>
          Models.CategoryModel.create(categoryItem)
        )
      : null;

    return modeledData;
  }

  get categoryCountry(): ICategoryModel[] {
    const country = get(
      this._config,
      'elements.case_study_categories__country.value',
      null
    );
    const modeledData = country
      ? country.map((categoryItem: ICategory) =>
          Models.CategoryModel.create(categoryItem)
        )
      : null;

    return modeledData;
  }

  public static create(data: ICaseStudyListItem): ICaseStudyListItemProps {
    const {
      language,
      slug,
      title,
      summary,
      image,
      id,
      categoryIndustry,
      categoryTechnology,
      categoryProject,
      categoryCountry
    } = new CaseStudyListItemModel(data);

    return {
      language,
      id,
      slug,
      title,
      summary,
      image,
      categoryIndustry,
      categoryTechnology,
      categoryProject,
      categoryCountry
    };
  }
}
